import Layout from "@/layouts";
import {i18n} from "@/utils/i18n";

const invoice = {
  path: "/invoice",
  component: Layout,
  name: "invoice",
  redirect: "/invoice/index",
  children: [
    {
      path: "/invoice/index",
      component: () => import("@/views/invoice/index"),
      name: "invoice.index",
      meta: { title: i18n.t(`message.invoice`) },
    },
  ],
};

export default invoice;
